import uuid from '../../../../utils/uuid';
import { BlockSelectionState } from '../../blocks/_models/blockSelectionState';

function getBlockChildren(blocks) {
	const children = [];

	for (const block of blocks) {
		children.push({
			id: block.id,
			name: block.title,
			type: block.type || 'tabOrCard',
			state: BlockSelectionState.notSelected,
			children: buildSelectionBranch(block.blocks)
		});
	}

	return children;
}

function addPopupChildren(block, children) {
	if (!block.actions) {
		return;
	}
	for (const action of block.actions) {
		if (action.type !== 'popup') {
			continue;
		}
		const selectionNode = createSelectionNodeOfAction(action);

		children.push(selectionNode);
	}
}

function getSelectionNodesOfFlipCardEnhancedBlock(flipCardBlock) {
	const children = [];
	children.push({
		id: flipCardBlock.data.front.id,
		name: 'Front Side',
		state: BlockSelectionState.notSelected,
		children: buildSelectionBranch(flipCardBlock.data.front.blocks)
	});
	children.push({
		id: flipCardBlock.data.back.id,
		name: 'Back Side',
		state: BlockSelectionState.notSelected,
		children: buildSelectionBranch(flipCardBlock.data.back.blocks)
	});
	addPopupChildren(flipCardBlock, children);

	return children;
}

function createSelectionNodeChildren(block) {
	let childrenSelectionNodes = undefined;
	switch (block.type) {
		case 'flipCardEnhanced':
			childrenSelectionNodes = getSelectionNodesOfFlipCardEnhancedBlock(block);
			break;
		case 'carousel':
			childrenSelectionNodes = getBlockChildren(block.data.cards);
			addPopupChildren(block, childrenSelectionNodes);
			break;
		case 'tabs':
			childrenSelectionNodes = getBlockChildren(block.data.tabs);
			addPopupChildren(block, childrenSelectionNodes);
			break;
		case 'flashCard':
			childrenSelectionNodes = [];
			childrenSelectionNodes.push({
				id: uuid(),
				name: 'FlashCard Question',
				state: BlockSelectionState.notSelected,
				children: buildSelectionBranch(block.data.blocks)
			});
			if (!block.data.overlays.answer.id) block.data.overlays.answer.id = uuid();
			childrenSelectionNodes.push({
				id: block.data.overlays.answer.id,
				name: 'FlashCard Answer',
				state: BlockSelectionState.notSelected,
				children: buildSelectionBranch(block.data.overlays.answer.blocks)
			});
			addPopupChildren(block, childrenSelectionNodes);
			break;
		case 'libraryContentCustom':
			childrenSelectionNodes = [];
			childrenSelectionNodes.push({
				id: uuid(),
				name: 'Library Content',
				state: BlockSelectionState.notSelected,
				children: buildSelectionBranch(block.data.blocks)
			});
			if (!block.data.overlays.expanded.id) block.data.overlays.expanded.id = uuid();
			childrenSelectionNodes.push({
				id: block.data.overlays.expanded.id,
				name: 'Library Content Expanded',
				state: BlockSelectionState.notSelected,
				children: buildSelectionBranch(block.data.overlays.expanded.blocks)
			});
			addPopupChildren(block, childrenSelectionNodes);
			break;
		case 'contentMultipleChoiceQuestion':
		case 'contentMultipleChoiceQuestionTemplate':
			childrenSelectionNodes = [];
			childrenSelectionNodes.push({
				id: uuid(),
				name: 'Multiple Choice Question',
				state: BlockSelectionState.notSelected,
				children: buildSelectionBranch(block.data.blocks)
			});
			if (!block.data.overlays.correct.id) block.data.overlays.correct.id = uuid();
			childrenSelectionNodes.push({
				id: block.data.overlays.correct.id,
				name: 'Multiple Choice - Correct',
				state: BlockSelectionState.notSelected,
				children: buildSelectionBranch(block.data.overlays.correct.blocks)
			});
			if (!block.data.overlays.incorrect.id) block.data.overlays.incorrect.id = uuid();
			childrenSelectionNodes.push({
				id: block.data.overlays.incorrect.id,
				name: 'Multiple Choice - Incorrect',
				state: BlockSelectionState.notSelected,
				children: buildSelectionBranch(block.data.overlays.incorrect.blocks)
			});
			addPopupChildren(block, childrenSelectionNodes);
			break;
		case 'adaptiveLearningResult':
			childrenSelectionNodes = [];
			childrenSelectionNodes.push({
				id: uuid(),
				name: 'Adaptive Learning Result',
				state: BlockSelectionState.notSelected,
				children: buildSelectionBranch(block.data.blocks)
			});
			addPopupChildren(block, childrenSelectionNodes);
			break;
		default:
			// "Simple Block": check for actions
			childrenSelectionNodes = [];
			addPopupChildren(block, childrenSelectionNodes);
			break;
	}
	return childrenSelectionNodes;
}

function createSelectionNodeOfAction(action) {
	const selectionNode = {
		id: action.id || uuid(),
		name: action.type,
		state: BlockSelectionState.notSelected,
		children: action.blocks ? buildSelectionBranch(action.blocks) : []
	};
	return selectionNode;
}

function createSelectionNodeOfBlock(block) {
	const childrenSelectionNodes = createSelectionNodeChildren(block);

	let selectionNodeName = block.name;
	if (selectionNodeName === '') {
		selectionNodeName = block.type + ' ' + block.id.slice(-4);
	}

	const selectionNode = {
		id: block.id,
		name: selectionNodeName,
		type: block.type,
		state: BlockSelectionState.notSelected
	};

	if (childrenSelectionNodes && childrenSelectionNodes.length > 0) {
		selectionNode.children = childrenSelectionNodes;
	}
	return selectionNode;
}

function buildSelectionBranch(blocks) {
	let selectionBranchNodes = [];
	for (const block of blocks) {
		const selectionNode = createSelectionNodeOfBlock(block);
		selectionBranchNodes.push(selectionNode);
	}
	return selectionBranchNodes;
}

export function buildSelectionTree(blocks) {
	return buildSelectionBranch(blocks);
}
